import { Routes, Route } from "react-router-dom";
import List from "./List";
// import View from "./View";
export const MODEL = "sku";
export const BASE_PATH = "/skus";
export const TITLE = ["Return", "Returns"];
export default function Entity(props: any) {
  return (
    <Routes>
      <Route path={`/`} element={<List />} />
    </Routes>
  );
}
